/** Customer payment status poll intervals (FE load / FIO rate-limit policy). */

/** FIO / bank-transfer floor — always while PENDING; never SSE-gated. */
export const FIO_PAYMENT_STATUS_POLL_MS = 31_000;

/** Gateway/ThePay deny-list interval (kiosk SSE-down path); not used for FIO rails. */
export const GATEWAY_PAYMENT_STATUS_POLL_MS = 3_000;

/** Staff cash confirmation — faster than FIO floor while customer waits on cash-collect (G9). */
export const CASH_PAYMENT_STATUS_POLL_MS = GATEWAY_PAYMENT_STATUS_POLL_MS;
